/* ==========================================================================
   Naudet (ClaudIA) — Lien « Gérer les cookies » du pied de page. 2026-09-24.

   Demande : audit d'Olivier Bouan, point 2 (consentement RGPD avant les
   publicités Meta) : « ajouter un lien Politique de confidentialité et
   Préférences cookies dans le pied de page ».

   Le bandeau de consentement est celui de Shopify (Paramètres →
   Confidentialité des clients). Il n'offre aucun lien permanent : une fois
   qu'un visiteur a répondu, il ne peut plus revenir sur son choix. Ce script
   donne ce retour : tout lien dont l'adresse se termine par `#naudet-cookies`
   rouvre la fenêtre des préférences du bandeau Shopify.

   Le lien lui-même est un simple texte du pied de page, que Morgane peut
   déplacer ou renommer dans l'éditeur : seule compte l'adresse
   `#naudet-cookies`.

   Repli : si le bandeau Shopify n'est pas chargé (visiteur hors zone où
   Shopify l'affiche, ou bandeau désactivé), le lien mène à la politique de
   confidentialité plutôt que de ne rien faire.
   ========================================================================== */

(() => {
  'use strict';

  const CIBLE = '#naudet-cookies';

  document.addEventListener('click', (e) => {
    const lien = e.target instanceof Element ? e.target.closest('a[href]') : null;
    if (!lien) return;
    const href = lien.getAttribute('href') || '';
    if (!href.endsWith(CIBLE)) return;

    e.preventDefault();
    const banniere = window.privacyBanner;
    if (banniere && typeof banniere.showPreferences === 'function') {
      banniere.showPreferences();
    } else {
      window.location.href = '/policies/privacy-policy';
    }
  });
})();
